export enum LeftSectionItemId {
    EMAIL = 'email',
    PHONE_NUMBER = 'phoneNumber',
    STATE = 'state',
    CREATED_ON = 'createdOn',
    LAST_LOGIN_ON = 'lastLoginOn',
}

export const NEVER_LOGGED_IN = 'Never logged in';